import Button from 'react-bootstrap/Button'

const shippersEdgeUrl = process.env.REACT_APP_SHIPPERSEDGE_URL

function LearnMoreButton() {
  const handleClick = () => { document.location = shippersEdgeUrl }
  return <Button variant="primary" onClick={handleClick}>Learn More</Button>
}

export default LearnMoreButton
